import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PhoneService } from '../services';
import { Phone, Variant, PhoneList } from '../models';

@Component({
  selector: 'app-phone-or-variant',
  templateUrl: './phone-or-variant.component.html',
  styleUrls: ['./phone-or-variant.component.scss']
})
export class PhoneOrVariantComponent implements OnInit, OnDestroy {
  private sub;
  brandId: string;
  phoneId: string;
  variantNameId: string;
  phone: Phone;
  variant: Variant;
  variants: Variant[] = [];
  phoneList: PhoneList;
  showComponent: string = '';
  // suggestedPhones: Phone[];

  constructor(private route: ActivatedRoute, private phoneService: PhoneService) { }

  ngOnInit() {
    // console.log(this.route);
    this.sub = this.route.params
      .switchMap(routeParams => {
          this.brandId = routeParams['brandId'];
          this.phoneId = routeParams['phoneId'];
          this.variantNameId = routeParams['variantNameId'];
          return this.phoneService.obs.phoneList;
        })
      .subscribe((phoneList: PhoneList) => {
        this.phone = phoneList.brands.get(this.brandId).phones.get(this.phoneId);
        // console.log(this.variantNameId, this.phone.variants.values());
        // console.log(this.phone);
        if (this.variantNameId) {
          // Show the variant
          this.variant = this.phone.getVariantByNameId(this.variantNameId);
          this.showComponent = 'variant';
        } else {
          this._loadPhoneVariantOrSingleVariant();
        }
      });
  }

  _loadPhoneVariantOrSingleVariant() {
    if (this.phone.variants.size === 1)  {
      // Load the single variant
      this.variant = this.phone.variants.values().next().value;
      this.showComponent = 'variant';
    } else {
      this.showComponent = 'phone';
      // Show all the variants for that phone
      // this.variants = <Array<Variant>>Array.from(this.phone.variants.values());
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/phone-or-variant/phone-or-variant.component.ts